module.exports = __webpack_public_path__ + "static/media/kovan.14405d87.svg";